// @flow

import * as R from "ramda";
import { BackButton, Subtitle, Wrapper } from "./Header.styles";
import { type Color, getColor } from "views/resources/theme";
import { calculateFg } from "./utils";
import Icon, { Icons } from "react-hp-icons";
import React, { useDispatch, useState } from "reactn";
import theme from "views/resources/theme";
import type { History } from "react-router";
import type { Office } from "types";

interface Props {
	title: string;
	bg: string;
	fixed: boolean;
	styles: {| marginBottomx: string |};
	transparent?: boolean;
	fg?: Color;
	icon?: React$Node;
	goBack(): void;
}

const Header = ({
	title,
	bg = theme.colors.primary,
	fixed = false,
	transparent = false,
	styles = {},
	goBack,
	fg,
	icon,
}: Props) => {
	const font_color: string = fg
		? getColor(fg)({ theme })
		: transparent
		? theme.colors.fg_alt
		: calculateFg(bg);
	const background = transparent ? "transparent" : bg;
	const openDrawer = useDispatch("openDrawer");
	return (
		// $FlowFixMe
		<Wrapper styles={styles} bg={background} fg={font_color} fixed={fixed}>
			<BackButton onClick={goBack}>
				<Icon type={Icons.left} color={font_color} size={2} />
			</BackButton>
			{title && <h5>{title}</h5>}
			{icon || <DrawerIcon onClick={openDrawer} color={font_color} />}
		</Wrapper>
	);
};

interface IconProps {
	color: string;
	onClick(): void;
}

const DrawerIcon = ({ onClick, color }: IconProps) => (
	<div onClick={onClick}>
		<Icon type={Icons.menu} color={color} size={2} />
	</div>
);

interface DefaultHeaderProps {
	history: History;
	office: ?Office;
}

export const TransparentHeader = ({ goBack }: DefaultHeaderProps) => (
	<Header goBack={goBack} title="" transparent fixed icon={true} />
);

export const DefaultHeader = ({ goBack, office }: DefaultHeaderProps) => (
	<Header
		goBack={goBack}
		title={officeCategory(office)}
		bg={officeColor(office)}
		fixed
	/>
);

export const NoIcon = () => (
	<div style={{ width: "22px", height: "20px" }}> &nbsp; </div>
);
// $FlowFixMe
const officeColor = (office) => R.pathOr("", ["options", "color"], office);
// $FlowFixMe
const officeCategory = (office) => R.pathOr("", ["category", "name"], office);

export default Header;
